import { NavigateFunction } from 'react-router-dom';

export const handleRedirect = (url: string, navigate: NavigateFunction) => {
    if (url.startsWith('/')) {
        navigate(url);
    } else {
        window.open(url, '_blank')?.focus();
    }
};
